/* Syd's House - Measurements Formatter
   - Parses the plain-text description into measurements / meta / other
   - Renders the measurements table inline (no click required)
   - Shipping & Duties block removed (superseded by syd-delivery-estimate)
   - Modal removed (superseded by the category-aware Measurement Guide accordion)
   - Styles are injected here so this file is self-contained */
document.addEventListener('DOMContentLoaded', function () {
  var descEl = document.querySelector('.product__description');
  if (!descEl) return;

  if (!document.getElementById('syd-meas-styles')) {
    var css = document.createElement('style');
    css.id = 'syd-meas-styles';
    css.textContent =
      '.syd-desc-prose{margin:0 0 1rem;font-size:1.6rem;line-height:1.7;}' +
      '.syd-meas-table{width:100%;border-collapse:collapse;margin:1.2rem 0;}' +
      '.syd-meas-table th{text-align:left;padding:1rem 0.8rem;font-size:1.5rem;font-weight:700;' +
        'color:rgb(var(--color-foreground));border-bottom:2px solid rgb(var(--color-foreground));}' +
      '.syd-meas-table td{padding:1rem 0.8rem;font-size:1.5rem;' +
        'border-bottom:1px solid rgba(var(--color-foreground),0.12);}' +
      '.syd-meas-table tbody tr:nth-child(odd){background:rgba(var(--color-foreground),0.04);}' +
      '.syd-meas-table td:last-child{font-weight:700;}' +
      '.syd-desc-meta{margin-top:1rem;font-size:1.5rem;line-height:1.8;font-weight:500;' +
        'color:rgba(var(--color-foreground),0.8);}';
    document.head.appendChild(css);
  }

  var pitToPitLabel = descEl.dataset.pitToPitLabel || 'Pit to pit';
  var measurementKeys = [pitToPitLabel, 'P2P', 'Pit to pit', 'Length', 'Sleeve', 'Leg', 'Waist', 'Chest', 'Width', 'Shoulder'];
  var metaKeys = ['Size', 'Colour', 'Color', 'Condition'];

  var normalized = descEl.innerHTML
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n')
    .replace(/<p[^>]*>/gi, '')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/\r/g, '')
    .replace(/\bp2p\b/gi, pitToPitLabel);

  var lines = normalized.split('\n')
    .map(function (l) { return l.trim(); })
    .filter(function (l) { return l.length > 0; });

  var measurements = [];
  var meta = [];
  var other = [];

  lines.forEach(function (line) {
    var isMeasurement = measurementKeys.some(function (k) {
      return line.toLowerCase().startsWith(k.toLowerCase());
    });
    var isMeta = metaKeys.some(function (k) {
      return line.toLowerCase().startsWith(k.toLowerCase());
    });
    if (isMeasurement) {
      var parts = line.split(/[-\u2013:]/);
      var label = parts[0].trim();
      var value = parts.slice(1).join('-').trim();
      if (value && /^\d/.test(value) && !/inch|in\b|"/.test(value)) value = value + '"';
      measurements.push({ label: label, value: value });
    } else if (isMeta) {
      meta.push(line);
    } else {
      other.push(line);
    }
  });

  var newHtml = '';

  if (other.length > 0) {
    newHtml += '<p class="syd-desc-prose">' + other.join('<br>') + '</p>';
  }

  if (measurements.length > 0) {
    newHtml += '<table class="syd-meas-table">'
      + '<thead><tr><th>Measurement</th><th>Inches</th></tr></thead><tbody>';
    measurements.forEach(function (m) {
      newHtml += '<tr><td>' + m.label + '</td><td>' + m.value + '</td></tr>';
    });
    newHtml += '</tbody></table>';
  }

  if (meta.length > 0) {
    newHtml += '<div class="syd-desc-meta">' + meta.join('<br>') + '</div>';
  }

  descEl.innerHTML = newHtml;
});
